// import { LOCAL_STORAGE } from '../../constants';
import React from 'react';
import { getLocalStorageItem } from '../localStorage';
import { capitalize } from '../misc';

export function dispatchDataCompiler(data = []) {
  let finalData = [];

  data.forEach((obj) => {
    let dispatchData = {
      url: obj?.name?.replaceAll('/', '_'),
      priority: capitalize(String(obj?.manufacture_priority || '').replaceAll('_', ' ')),
      id: obj.id,
      shipment_no: obj.name || 'N/A',
      contact: obj?.partner_id?.name || 'N/A',
      invoice_no: obj?.invoice_no || 'N/A',
      vendor_type: obj?.partner_id?.vendor_type || 'N/A',
      user_type: obj?.vendor_id?.vendor_type || 'N/A',
      lot: obj?.lot_name || 'N/A',
      backorder_of: obj?.backorder_id?.name || 'N/A',
      shipment_date: obj?.scheduled_date ? obj.scheduled_date.split(' ')[0] : 'N/A',
      box_count: obj?.box_count || 'N/A',
      dispatch_status: capitalize(String(obj?.dispatch_status || '')),
      state: capitalize(String(obj?.state || '')),
      origin: capitalize(String(obj?.partner_ref || obj?.origin || '')) || 'N/A',
      physical_container_no: obj?.physical_container_no || 'N/A',
      finished_product: obj?.finished_products || 'N/A',
      lot_color: obj?.lot_color || 'N/A',
      lot_size: obj?.lot_size || 'N/A',
      rib_color: obj?.rib_color || 'N/A',
      rib_size: obj?.rib_size || 'N/A',
      dispatch_bill_id: obj?.dispatch_bill_id || 'N/A',
      data: obj,
    };

    finalData.push(dispatchData);
  });

  return finalData;
}

export function dispatchDetailsBox(dispatch, dispatchData = false, isLoading = false, invoiceNo) {
  const vendorType = getLocalStorageItem('vendor_type');

  let finalData = [
    { name: 'Name', col: 1, data: dispatch?.name },
    { name: 'Partner', col: 1, data: dispatch?.partner_id?.name || 'N/A' },
    {
      name: 'Source',
      col: 1,
      data: capitalize(dispatch?.partner_ref) || dispatch?.origin || 'N/A',
    },
    {
      name: 'Backorder Of',
      col: 2,
      data: dispatch?.backorder_id?.name || 'N/A',
    },
  ];

  if (vendorType !== 'dyeing') {
    finalData.push({
      name: 'Lot',
      col: 1,
      data: dispatch?.lot_name || 'N/A',
    });
  }

  if (dispatchData) {
    finalData.push({
      name: 'Invoice No',
      col: 1,
      isCustom: true,
      view: ({ value, setValue }) => (
        <div className="row mb-3">
          <div className="col-6 title d-flex flex-wrap t-wrap">Invoice No</div>
          <div className="col-6">
            <input
              type="text"
              className="form-control"
              value={value.invoice_no || ''}
              onChange={(e) => setValue((prev) => ({ ...prev, invoice_no: e.target.value }))}
              disabled={
                isLoading ||
                dispatch?.dispatch_status !== 'draft' ||
                dispatch?.state === 'done' ||
                dispatch?.state === 'cancel'
              }
            />
          </div>
        </div>
      ),
    });
  }

  finalData.push(
    { name: 'Scheduled Date', col: 2, data: dispatch?.scheduled_date?.split(' ')[0] },
    { name: 'Status', col: 2, data: capitalize(dispatch?.state) },
    { name: 'Dispatch Status', col: 2, data: capitalize(dispatch?.dispatch_status) },
  );

  if (vendorType === 'fabric') {
    finalData.push({
      name: 'Priority',
      col: 2,
      data: capitalize(dispatch?.manufacture_priority) || 'N/A',
    });
  }
  if (vendorType === 'fabric' && !dispatchData) {
    finalData.push({
      name: 'Invoice No',
      col: 1,
      data: capitalize(invoiceNo) || 'N/A',
    });
  }

  // if (vendorType === 'fabric' && dispatchData) {
  //   finalData.push({
  //     name: 'Lot Color',
  //     col: 1,
  //     data: capitalize(dispatch?.lot_color) || 'N/A',
  //   },
  //   {
  //     name: 'Lot Size',
  //     col: 1,
  //     data: capitalize(dispatch?.lot_size) || 'N/A',
  //   },
  //   {
  //     name: 'Rib Color',
  //     col: 2,
  //     data: capitalize(dispatch?.rib_color) || 'N/A',
  //   },
  //   {
  //     name: 'Rib Size',
  //     col: 2,
  //     data: capitalize(dispatch?.rib_size) || 'N/A',
  //   },
  // )
  // }

  if (vendorType === 'clothing' || vendorType === 'dyeing') {
    finalData.push({
      name: 'Finished Product',
      col: 2,
      data: dispatch?.finished_products || 'N/A',
    });
  }
  if (vendorType !== 'fabric' && vendorType !== 'dyeing') {
    const userName = getLocalStorageItem('username');
    const isTexshann = userName === 'TEXSHANN EXPORTS';
    
    if (dispatchData) {
      finalData.push({
        name: 'Container No',
        col: 1,
        isCustom: true,
        view: ({ value, setValue }) => (
          <div className="row mb-3">
            <div className="col-6 title d-flex flex-wrap t-wrap">Container No</div>
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                value={value.container_no || ''}
                onChange={(e) => setValue((prev) => ({ ...prev, container_no: e.target.value }))}
                disabled={isLoading || (!isTexshann && dispatch?.dispatch_status !== 'draft')}
              />
            </div>
          </div>
        ),
      });
    } else {
      finalData.push({
        name: 'Container No',
        col: 1,
        data: dispatch?.physical_container_no || 'N/A',
      });
    }
  }

  return finalData;
}

export function fabricDispatchProductCompiler(data = []) {
  let finalData = [];
  const vendor_shipment = data?.vendor_shipment;
  const container = data?.invoice_no;
  const physical_container_no = data?.physical_container_no;
  data?.move_ids?.forEach((obj) => {
    let dispatchProductsData = {
      move_id: obj.id,
      vendor_shipment,
      rolls: obj?.no_of_rolls,
      shipped_by_esun: obj?.shipped_from_esun || 'N/A',
      lotno: vendor_shipment
        ? obj?.move_line_ids?.[0]?.lot_id?.name || 'N/A'
        : obj?.move_line_ids?.[0]?.lot_name || 'N/A',
      demand_quantity: obj.product_uom_qty,
      producing_quantity: obj.quantity,
      container,
      physical_container_no,
      unit: obj.product_uom?.name,
      product: obj.product_id?.display_name,
      data: obj,
      // edit: obj.subcontract_has_been_recorded,
      damaged_quantity: obj?.dispatch_damage_qty || obj?.damage_qty || 0,
      total_damaged_quantity: obj?.total_dispatch_damage_qty || obj?.total_damage_qty || 0,
      color: obj?.product_id?.variant_color || 'N/A',
      size: obj?.product_id?.variant_size || 'N/A',
    };
    finalData.push(dispatchProductsData);
  });
  return finalData;
}

export function dispatchCompiler(data = []) {
  let finalData = [];
  const container = data.invoice_no;
  const physical_container_no = data?.physical_container_no;
  data.move_ids.forEach((obj) => {
    let dispatchProductsData = {
      ...obj,
      container,
      physical_container_no,
      damaged_quantity: obj?.dispatch_damage_qty || obj?.damage_qty || 0,
      total_damaged_quantity: obj?.total_dispatch_damage_qty || obj?.total_damage_qty || 0,
    };
    finalData.push(dispatchProductsData);
  });
  return finalData;
}

export function yarnDispatchProductCompiler(data = []) {
  let finalData = [];
  if (Array.isArray(data) && data.length > 0) {
    data.forEach((obj) => {
      let dispatchProductsData = {
        move_id: obj?.id,
        rolls: obj?.no_of_rolls,
        damaged_quantity: obj?.dispatch_damage_qty || obj?.damage_qty || 0,
        total_damaged_quantity: obj?.total_dispatch_damage_qty || obj?.total_damage_qty || 0,
        lotno:
          obj?.product_id?.tracking === 'lot'
            ? obj?.move_line_ids?.[0]?.lot_name
              ? obj.move_line_ids[0].lot_name
              : 'N/A'
            : 'N/A',
        demand_quantity: obj?.product_uom_qty,
        producing_quantity: obj?.quantity,
        unit: obj?.product_uom?.name,
        product: obj?.product_id?.display_name,
        data: obj,
        // edit: obj?.subcontract_has_been_recorded,
      };
      finalData.push(dispatchProductsData);
    });
  }

  return finalData;
}

export function shipmentDataCompiler(data) {
  let finalData = [];
  if (data?.package_level_ids) {
    data.package_level_ids.forEach((obj) => {
      let shipmentData = {
        package_id: obj.package_id?.id,
        BLP: obj.package_id?.name,
        SKU: obj.package_id?.quant_ids[0]?.product_id?.default_code,
        Batch: obj.package_id?.quant_ids[0]?.lot_id?.name,
        SKU_Details: obj?.package_id.quant_ids?.map((sku) => ({
          SKU: sku.product_id?.display_name,
          'Batch No.': sku.lot_id?.name,
          Quantity: sku.quantity + ' Unit',
        })),
        data: obj,
        isBillAlreadyCreated: data?.dispatch_bill_id ? data?.dispatch_bill_id['id'] : false,
      };
      finalData.push(shipmentData);
    });
  } else if (data?.package_id) {
    const obj = data.package_id;

    let shipment_data = {
      package_id: obj?.id,
      BLP: obj?.name,
      SKU: obj?.quant_ids?.[0]?.product_id?.default_code,
      Batch: obj?.quant_ids?.[0]?.lot_id?.name,
      SKU_Details: obj?.quant_ids?.map((sku) => ({
        SKU: sku.product_id?.display_name,
        'Batch No.': sku.lot_id?.name,
        Quantity: sku.quantity + ' Unit',
      })),
      data: obj,
      isBillAlreadyCreated: data?.dispatch_bill_id ? data?.dispatch_bill_id['id'] : false,
    };

    finalData.push(shipment_data);
  }
  return finalData;
}
